<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-bind:disabled="!currentUsername" v-on:submit.prevent="submitForm" data-cy="login-2fa-form">
        <v-container>

          <v-row class="text-truncate justify-center" v-if="currentUsername" data-cy="login-2fa-user-mail">
            <v-tooltip location="bottom" z-index="1200">
              <template v-slot:activator="{ props }">
                <span v-bind="props" class="mb-2">
                  <b>{{currentUsername}}</b>
                </span>
              </template>
              <span>{{currentUsername}}</span>
            </v-tooltip>
          </v-row>

          <v-row class="justify-center">
            <span class="mb-5">
              Please enter your one-time password.
            </span>
          </v-row>


          <v-row class="">
            <v-text-field
              v-model="oneTimeCode"
              label="One-time password"
              :rules="oneTimeCodeRules"
              autocomplete="off"
              prepend-inner-icon="mdi-timer-lock-outline"
              block
              variant="solo-filled" flat
              data-cy="login-2fa-password-field"
            />
          </v-row>

          <v-row v-if="errorMessage" class="inline-message--error mb-4" data-cy="login-2fa-errorMessage">
            {{ errorMessage }}
          </v-row>

          <v-row v-if="!isSessionExpired" class="">
            <v-btn
              type="submit"
              class="bg-primary"
              :disabled="isFormSubmitted"
              :loading="isFormSubmitted"
              block
              data-cy="login-2fa-login-btn"
            >
              Login
            </v-btn>
          </v-row>

          <v-row v-if="isSessionExpired" class="">
            <v-btn to="/account/login" class="bg-primary" block data-cy="login-2fa-redirectToLoginPage-btn">Login page</v-btn>
          </v-row>
        </v-container>
      </v-form>

    </div>

  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore';
import CognitoRedirectingMixin from './CognitoRedirectingMixin.js';
import LoginLogo from './components/LoginLogo.vue';


export default {
  name: "AccountLoginOTP",
  mixins: [CognitoRedirectingMixin],
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      errorMessage: '',
      isFormSubmitted: false,

      oneTimeCode: '',
      oneTimeCodeRules: [
        v => !!v || "One-time password is required!",
        v => /^\d{6}$/.test(v) || "Invalid one-time password!"
      ],
    };
  },
  mounted: function() {
    if (!this.currentUsername) {
      this.$router.push('/account/login');
    }
  },
  methods: {
    submitForm: async function() {
      const validForm = await this.$refs.form.validate();
      this.errorMessage = '';

      if (!validForm.valid) {
        return;
      }

      this.isFormSubmitted = true;

      try {
        const authStore = useAuthStore();
        const cognitoResponse = await authStore.confirmTOTP(this.oneTimeCode);

        await this.cognitoRedirectingMixin(cognitoResponse, this.currentUsername);
      } catch (error) {
        if (error && error.message) {
          this.errorMessage = error.message;
        } else {
          // unhandled error
          this.errorMessage = "Error!"
          console.log("Error i got", error);
        }
      } finally {
        this.isFormSubmitted = false;
      }
    }
  },
  computed: {
    currentUsername: function() {
      if (window && window.tempCredentials && window.tempCredentials.username) {
        return window.tempCredentials.username;
      }

      return false;
    },
    isSessionExpired: function() {
      return this.errorMessage && this.errorMessage == "Invalid session for the user, session is expired.";
    }
  },
}
</script>

<style>
</style>
